"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.otwoo0101Detail = otwoo0101Detail;
exports.otwoo0102Detail = otwoo0102Detail;
exports.otwoo0103Detail = otwoo0103Detail;
exports.otwooDeptDetail = otwooDeptDetail;
exports.otwooServiceDetail = otwooServiceDetail;
exports.otwooUserDetail = otwooUserDetail;

var _request = _interopRequireDefault(require("@/utils/request"));

function otwooDeptDetail(data) {
  return (0, _request.default)({
    url: 'api/otwooStat/otwooDeptDetail',
    method: 'post',
    data: data
  });
}

function otwooUserDetail(data) {
  return (0, _request.default)({
    url: 'api/otwooStat/otwooUserDetail',
    method: 'post',
    data: data
  });
}

function otwooServiceDetail(data) {
  return (0, _request.default)({
    url: 'api/otwooStat/otwooServiceDetail',
    method: 'post',
    data: data
  });
}

function otwoo0101Detail(data) {
  return (0, _request.default)({
    url: 'api/otwooStat/otwoo0101Detail',
    method: 'post',
    data: data
  });
}

function otwoo0102Detail(data) {
  return (0, _request.default)({
    url: 'api/otwooStat/otwoo0102Detail',
    method: 'post',
    data: data
  });
}

function otwoo0103Detail(data) {
  return (0, _request.default)({
    url: 'api/otwooStat/otwoo0103Detail',
    method: 'post',
    data: data
  });
}

var _default = {
  otwooDeptDetail: otwooDeptDetail,
  otwooUserDetail: otwooUserDetail,
  otwooServiceDetail: otwooServiceDetail,
  otwoo0101Detail: otwoo0101Detail,
  otwoo0102Detail: otwoo0102Detail,
  otwoo0103Detail: otwoo0103Detail
};
exports.default = _default;